import * as React from 'react';
import { Table, Card, Avatar } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import { Query, QuerySnapshot } from '@firebase/firestore-types';
import * as firebase from 'firebase/app';
import { Member } from 'src/store';
import { DisplayDate } from '../../components';
import { Subscription, Observable } from 'rxjs';

// const mapStateToProps = ({ membersState }: AppState) => {
//   return {
//     membersState,
//   };
// };

// const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
//   return {
//     onPageChange: (page: number, startAfter?: QueryDocumentSnapshot) => {
//       dispatch(actions.listenCollection(page, startAfter));
//     },
//     unlistenCollection: () => {
//       dispatch(actions.unlistenCollection());
//     },
//     navigate: (route: string) => {
//       dispatch(push(route));
//     },
//     onEdit: (id: string) => { dispatch(push(`/merchants/edit/${id}`)); },
//     onDelete: async (id: string) => {
//       const ref = firestore.collection('merchants');
//       if (id) {
//         const doc = ref.doc(id)
//         await doc.delete()
//         dispatch(toast.success('Merchant is deleted successfully.'));
//         // dispatch(push('/merchants'));
//       }
//     },
//   };
// };

interface P {
  // membersState: CollectionState<Member>;
  // onPageChange: (page: number, startAfter?: QueryDocumentSnapshot) => void;
  // unlistenCollection: () => void;
  // navigate: (route: string) => void;
  onEdit: (id: string) => void;
  // onDelete: (id: string) => Promise<void>;
}

interface S {
  data: Member[];
  loading?: boolean;
  currentPage: number;
}

class MemberList extends React.Component<P, S> {
  subscription: Subscription;
  columns: ColumnProps<Member>[];
  queryRef: Query;
  pageSize: number;

  constructor(props: P) {
    super(props);
    this.subscription = new Subscription();
    this.pageSize = 10;
    this.state = { data: [], loading: false, currentPage: 1 };
    this.queryRef = firebase.firestore()
      .collection('members')
      .orderBy('metadata.creationTime', 'desc');
  }

  componentDidMount() {
    this.handlePageChange(1);
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handlePageChange = (page: number) => {
    const paginatedRef = this.queryRef;
    this.setState({ loading: true });
    // if (page > 1) {
    //     paginatedRef = this.queryRef.endAt(page);
    // }

    const members$ = new Observable<QuerySnapshot>(observer => {
      return paginatedRef.onSnapshot(sn => observer.next(sn));
    });

    this.subscription = members$.subscribe(sn => {
      if (!sn.empty) {
        const data = sn.docs.map(d => ({ ...d.data(), id: d.id } as Member));
        this.setState({ data, loading: false, currentPage: page });
      } else {
        this.setState({ data: [], loading: false, currentPage: page });
      }
    });
  }

  // handleOnRow = (record: Member, index: number) => {
  //   return {
  //     onClick: () => {
  //       const { navigate } = this.props;
  //       navigate(`/merchants/edit/${record.id}`);
  //     }
  //   };
  // }

  // handleOnAdd = () => {
  //   const { navigate } = this.props;
  //   navigate(`/merchants/create`);
  // }

  getDataSource = () => {
    const { data, loading, currentPage } = this.state;
    const page = loading ? 1 : currentPage;
    const ds = !loading ?
      data.map((obj, i) => ({
        // no: ((page - 1) * this.pageSize) + (i + 1),
        no: i + 1,
        key: obj.id,
        ...obj,
      })) : [];

    return {
      ds,
      page,
    };
  }

  render() {
    const { ds } = this.getDataSource();
    const { loading } = this.state;
    this.columns = [{
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: "5%",
      render: (text: string, record: Member, index: number) => {
        return <span>{record.no}</span>;
      }
    },
    {
      title: 'Image',
      dataIndex: 'imageName',
      key: 'imageName',
      width: "10p%",
      // tslint:disable-next-line:no-any
      render: (text: string, record: Member) => (
        <span>
          <Avatar
            src={record.photo}
            className="img-circle"
          />
        </span>
      )
    },
    {
      title: 'Display Name',
      dataIndex: 'displayName',
      key: 'displayName',
      width: '20%',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '20%',
    },
    {
      title: 'Phone',
      dataIndex: 'phoneNumber',
      key: 'loginUserName',
      width: '15%',
    },
    {
      title: 'Created',
      dataIndex: 'created',
      width: '15%',
      // tslint:disable-next-line:no-any
      render: (text: string, record: any) => {
        return <DisplayDate dateTime={record.metadata.creationTime} />
      }
    },
    {
      title: 'Signed In',
      dataIndex: 'signedIn',
      width: '15%',
      // tslint:disable-next-line:no-any
      render: (text: string, record: any) => {
        return <DisplayDate dateTime={record.metadata.lastSignInTime} />
      }
    },

    ];

    return (
      <Card
        loading={loading}
        title="Member List"
        bordered={true}
        bodyStyle={{ padding: 10 }}
      >
        <Table
          // loading={merchantsState.status === 'loading'}
          columns={this.columns}
          dataSource={ds}
          // onRow={this.handleOnRow}
          pagination={{
            // current: page || 0,
            // pageSize: 50,
            // total: ds.length || 0, 
            // onChange: this.handlePageChange,
            showTotal: (total) => <span className="total-count">Total Count: {total}</span>
          }}
          size="middle"
          bordered={true}
        />
      </Card>
    );
  }
}

export default MemberList;



// WEBPACK FOOTER //
// ./src/members/containers/MemberList.tsx